"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TableHeading;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _material = require("@mui/material");
var _queryString = require("query-string");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRouterDom = require("react-router-dom");
function TableHeading(_ref) {
  var classes = _ref.classes,
    id = _ref.id,
    search = _ref.search,
    sorting = _ref.sorting,
    sortings = _ref.sortings,
    sortKey = _ref.sortKey,
    translationKey = _ref.translationKey,
    translationKeyRoot = _ref.translationKeyRoot,
    type = _ref.type,
    style = _ref.style,
    icon = _ref.icon;
  if (type === 'expandable') {
    return null;
  }
  if (sorting) {
    var sort = '';
    var otherSortings = sortings;
    var sortKeyIndex = sortings.findIndex(function (a) {
      return a[0] === sortKey;
    });
    if (sortKeyIndex !== -1) {
      if (sortings[0][0] === sortKey) {
        var _sortings$sortKeyInde = (0, _slicedToArray2.default)(sortings[sortKeyIndex], 2);
        sort = _sortings$sortKeyInde[1];
      }
      otherSortings = [].concat((0, _toConsumableArray2.default)(sortings.slice(0, sortKeyIndex)), (0, _toConsumableArray2.default)(sortings.slice(sortKeyIndex + 1)));
    }
    var oppositeSort = sort === 'asc' ? 'desc' : 'asc';
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.tableHeadCell,
      id: id,
      style: style
    }, /*#__PURE__*/_react.default.createElement(_material.Button, {
      className: classes.tableHeadCellAction,
      component: _reactRouterDom.Link,
      fullWidth: true,
      id: "".concat(id, "Button"),
      to: {
        search: (0, _queryString.stringify)((0, _extends2.default)({}, search, {
          orderBy: [[sortKey, oppositeSort]].concat((0, _toConsumableArray2.default)(otherSortings)).map(function (a) {
            return a.join(':');
          }).join(',')
        }))
      },
      variant: "text"
    }, /*#__PURE__*/_react.default.createElement(_material.TableSortLabel, {
      active: !!sort,
      className: classes.tableHeadCellActionText,
      direction: sort || undefined
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: classes.tableHeadCellActionText
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: "".concat(translationKeyRoot ? "".concat(translationKeyRoot, ".") : '', "table.").concat(translationKey || sortKey)
    })))));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.tableHeadCell,
    style: style
  }, icon ? /*#__PURE__*/_react.default.createElement(_material.Grid, {
    alignItems: "center",
    container: true,
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: classes.tableHeadCellAction,
    disabled: true,
    fullWidth: true,
    id: "".concat(id, "Button"),
    variant: "text"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.tableHeadCellActionText
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "".concat(translationKeyRoot ? "".concat(translationKeyRoot, ".") : '', "table.").concat(translationKey || sortKey)
  })))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, " ", icon, " ")) : /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: classes.tableHeadCellAction,
    disabled: true,
    fullWidth: true,
    id: "".concat(id, "Button"),
    variant: "text"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.tableHeadCellActionText
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "".concat(translationKeyRoot ? "".concat(translationKeyRoot, ".") : '', "table.").concat(translationKey || sortKey)
  }))));
}